import { render, staticRenderFns } from "./editor_long_chapter_write.vue?vue&type=template&id=a8b197b8&scoped=true"
import script from "./editor_long_chapter_write.vue?vue&type=script&lang=js"
export * from "./editor_long_chapter_write.vue?vue&type=script&lang=js"
import style0 from "./editor_long_chapter_write.vue?vue&type=style&index=0&id=a8b197b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b197b8",
  null
  
)

export default component.exports